export { sendMail, sendMoreNotification } from './service';



// WEBPACK FOOTER //
// ./src/common/services/mail.services/index.js